export default __webpack_public_path__ + "static/media/98t.04cb2c79.jpg";